<template>
  <div
    ref="container"
    class="lp-flip-card"
    :class="[
      currentSide === Sides.BACK && 'flipped',
      `w-${width}`,
      sameHeight && 'same-height',
    ]"
    :style="flipCardStyle"
    :data-ua-unique-id="dataUaUniqueId"
    v-bind="$attrs"
  >
    <div class="lp-card-wrapper">
      <slot name="front-card" />
    </div>
    <div class="lp-card-wrapper">
      <slot name="back-card" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, provide, Ref, ref } from 'vue'

defineOptions({
  name: 'lp-flip-card',
})

interface Props {
  width?: string
  sameHeight?: boolean
  dataUaUniqueId?: string
}

enum Sides {
  FRONT = 'front',
  BACK = 'back',
}

const props = withDefaults(defineProps<Props>(), {
  width: '100',
  sameHeight: true,
  dataUaUniqueId: 'unique-flip-card',
})

const emit = defineEmits(['on-flip'])

const currentSide = ref(Sides.FRONT)
const container: Ref<HTMLElement | null> = ref(null)

function nextSide() {
  return currentSide.value === Sides.FRONT ? Sides.BACK : Sides.FRONT
}

function onFlip() {
  currentSide.value = nextSide()
  emit('on-flip', currentSide.value)
}

provide('onFlip', onFlip)

const flipCardStyle = computed(() => {
  if (container.value) {
    const currentCard = container.value.querySelector(
      currentSide.value === Sides.FRONT ? '.lp-front-card' : '.lp-back-card',
    )

    if (currentCard) {
      const { height } = currentCard.getBoundingClientRect()

      return {
        height: `${height}px`,
      }
    }
  }

  return {
    height: 0,
  }
})
</script>
